export const statesDropdownOptions = [
  { value: 'Alabama', label: 'AL - Alabama' },
  { value: 'Alaska', label: 'AK - Alaska' },
  { value: 'Arizona', label: 'AZ - Arizona' },
  { value: 'Arkansas', label: 'AR - Arkansas' },
  { value: 'American Samoa', label: 'AS - American Samoa' },
  { value: 'California', label: 'CA - California' },
  { value: 'Colorado', label: 'CO - Colorado' },
  { value: 'Connecticut', label: 'CT - Connecticut' },
  { value: 'Delaware', label: 'DE - Delaware' },
  { value: 'District of Columbia', label: 'DC - District of Columbia' },
  { value: 'Florida', label: 'FL - Florida' },
  { value: 'Georgia', label: 'GA - Georgia' },
  { value: 'Guam', label: 'GU - Guam' },
  { value: 'Hawaii', label: 'HI - Hawaii' },
  { value: 'Idaho', label: 'ID - Idaho' },
  { value: 'Illinois', label: 'IL - Illinois' },
  { value: 'Indiana', label: 'IN - Indiana' },
  { value: 'Iowa', label: 'IA - Iowa' },
  { value: 'Kansas', label: 'KS - Kansas' },
  { value: 'Kentucky', label: 'KY - Kentucky' },
  { value: 'Louisiana', label: 'LA - Louisiana' },
  { value: 'Maine', label: 'ME - Maine' },
  { value: 'Maryland', label: 'MD - Maryland' },
  { value: 'Massachusetts', label: 'MA - Massachusetts' },
  { value: 'Michigan', label: 'MI - Michigan' },
  { value: 'Minnesota', label: 'MN - Minnesota' },
  { value: 'Mississippi', label: 'MS - Mississippi' },
  { value: 'Missouri', label: 'MO - Missouri' },
  { value: 'Montana', label: 'MT - Montana' },
  { value: 'Nebraska', label: 'NE - Nebraska' },
  { value: 'Nevada', label: 'NV - Nevada' },
  { value: 'New Hampshire', label: 'NH - New Hampshire' },
  { value: 'New Jersey', label: 'NJ - New Jersey' },
  { value: 'New Mexico', label: 'NM - New Mexico' },
  { value: 'New York', label: 'NY - New York' },
  { value: 'North Carolina', label: 'NC - North Carolina' },
  { value: 'North Dakota', label: 'ND - North Dakota' },
  { value: 'Northern Mariana Islands', label: 'MP - Northern Mariana Islands' },
  { value: 'Ohio', label: 'OH - Ohio' },
  { value: 'Oklahoma', label: 'OK - Oklahoma' },
  { value: 'Oregon', label: 'OR - Oregon' },
  { value: 'Pennsylvania', label: 'PA - Pennsylvania' },
  { value: 'Puerto Rico', label: 'PR - Puerto Rico' },
  { value: 'Rhode Island', label: 'RI - Rhode Island' },
  { value: 'South Carolina', label: 'SC - South Carolina' },
  { value: 'South Dakota', label: 'SD - South Dakota' },
  { value: 'Tennessee', label: 'TN - Tennessee' },
  { value: 'Texas', label: 'TX - Texas' },
  { value: 'Trust Territories', label: 'TT - Trust Territories' },
  { value: 'Utah', label: 'UT - Utah' },
  { value: 'Vermont', label: 'VT - Vermont' },
  { value: 'Virginia', label: 'VA - Virginia' },
  { value: 'Virgin Islands', label: 'VI - Virgin Islands' },
  { value: 'Washington', label: 'WA - Washington' },
  { value: 'West Virginia', label: 'WV - West Virginia' },
  { value: 'Wisconsin', label: 'WI - Wisconsin' },
  { value: 'Wyoming', label: 'WY - Wyoming' },
];
